const styles = (theme) => ({
  root: {
    '&&': {
      borderColor: theme.palette.primary.dark,
      borderWidth: '1px',
      borderStyle: 'solid',
      borderRadius: '5px',
      fontSize: '1.125rem',
      fontWeight: '500',
      [theme.breakpoints.up('sm')]: {
        fontSize: '1.1875rem',
      },
      margin: `-${theme.spacing.unit * 0.5}px 0`,
      minHeight: 35,
    },
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: theme.palette.primary.dark,
    },
  },
  standAlone: {
    '&&': {
      marginTop: theme.spacing.unit * 1.5,
    },
  },
  buttonLink: {
    color: theme.palette.text.dark,
    padding: `${theme.spacing.unit * 0.5}px ${
      theme.spacing.unit * 2.5
    }px !important`,
    [theme.breakpoints.up('sm')]: {
      minWidth: 216,
      padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px !important`,
    },
    '&:hover': {
      color: theme.palette.text.white,
    },
  },
});

export default styles;
